import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IPostDepartmentContent } from "apis/postDepartment";
import { RootState } from "store";
import { IDepartment, ManagerDepartmentsState } from "./type";

export const initialState: ManagerDepartmentsState = {
  access_token: undefined,
  is_loading_get_departmnet: false,
  is_loading_post_departmnet: false,
  departments: undefined,
};

const departmentsSlice = createSlice({
  name: "departmentState",
  initialState,
  reducers: {
    setTokenInfo(state, action: PayloadAction<string>) {
      state.access_token = action.payload;
    },

    getDepartmentStarted(state) {
      state.is_loading_get_departmnet = true;
      state.error = undefined;
    },
    getDepartmentSuccess(state, action: PayloadAction<IDepartment[]>) {
      state.is_loading_get_departmnet = false;
      state.departments = action.payload;
    },
    getDepartmentFailed(
      state,
      action: PayloadAction<ManagerDepartmentsState["error"]>
    ) {
      state.is_loading_get_departmnet = false;
      state.error = action.payload;
    },

    postDepartmentStarted(
      state,
      action: PayloadAction<IPostDepartmentContent>
    ) {
      state.is_loading_post_departmnet = true;
      state.error = undefined;
    },
    postDepartmentSuccess(state) {
      state.is_loading_post_departmnet = false;
    },
    postDepartmentFailed(
      state,
      action: PayloadAction<ManagerDepartmentsState["error"]>
    ) {
      state.is_loading_post_departmnet = false;
      state.error = action.payload;
    },
  },
});

export const departmentsActions = departmentsSlice.actions;

export const selectTokenLogin = (state: RootState) =>
  state.departmentState.access_token;

export const selectLoadingGetDepartment = (state: RootState) =>
  state.departmentState.is_loading_get_departmnet;

export const selectLoadingPostDepartment = (state: RootState) =>
  state.departmentState.is_loading_post_departmnet;

export const selectDepartments = (state: RootState) =>
  state.departmentState.departments;

const departmentsReducer = departmentsSlice.reducer;
export default departmentsReducer;
